var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#0d0d0d;stroke-miterlimit:10;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.571 -5801.229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.35 5802)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12.442,
    height: 9.872,
    rx: 1.7,
    transform: "translate(0 6.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.863,7.918V5.153A3.253,3.253,0,0,0,11.61,1.9H10.553A3.253,3.253,0,0,0,7.3,5.153V7.918Z",
    transform: "translate(-4.86 -1.9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.08b1d467a60d64127bf9ab2f4141f268.svg";
export { ForwardRef as ReactComponent };